export default __webpack_public_path__ + "static/media/game.80315756.jpg";